<template>
  <div class="podcast-banner">
    <div class="podcast-banner__container">

      <div class="podcast-banner__image">
        <img class src="/images/podcast-banner/podcast-banner-the-escape-artists.png" alt="A podcast by Escape the City" />
      </div>

      <div class="podcast-banner__content">
        <h2 class="podcast-banner__title">Our brand new podcast</h2>
        <h3 class="podcast-banner__sub-title">The Escape Artists</h3>
        <p class="podcast-banner__intro">Season 1: Just Launched</p>
        <p class="podcast-banner__description">
          Sharing incredible stories from those who have escaped, this podcasts is for anyone who needs a shot of inspiration and kick in the right direction that 'different is possible'.
        </p>
        <a class="btn btn-yellow" href="/podcast">Listen Now</a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PodcastBanner',

  data() {
    return {

    }
  },
}
</script>
